export default __webpack_public_path__ + "971e913.png";